import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/chrome/PageHeader';

const NotFound: React.FC = () => (
  <>
    <PageHeader title="404" subtitle="That page is in an air pocket — there's nothing here." />
    <div className="gv-stub">
      <Link to="/" className="gv-login-cta">RETURN HOME</Link>
    </div>
  </>
);

export default NotFound;
